import type { ReactElement } from 'react'
import { getSurface } from './migration'
import { Interstitial } from './Interstitial'

/**
 * Route gate (R22): only 'live' surfaces render their real component
 * inside the V2 shell — everything else gets the interstitial. The
 * gated element is lazy and never rendered while gated, so its chunk
 * is never fetched.
 */
export function Gate({ surface, el }: { surface: string; el: ReactElement }) {
  const def = getSurface(surface)
  if (def.status === 'live') return el
  return <Interstitial surface={def} />
}
